import { render, staticRenderFns } from "./contactCenHzzxOne.vue?vue&type=template&id=2b51432f&scoped=true"
import script from "./contactCenHzzxOne.vue?vue&type=script&lang=js"
export * from "./contactCenHzzxOne.vue?vue&type=script&lang=js"
import style1 from "./contactCenHzzxOne.vue?vue&type=style&index=1&id=2b51432f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b51432f",
  null
  
)

export default component.exports